import { DeliveryDescription } from '../../module/types/deliverySchema';
import { WrapperDeliveryBlock } from './WrapperDeliveryBlock';
import { useEffect } from 'react';
import { Htag } from '@ui-kit/Htag';

export const DeliveryByTransportCompany = ({ description, name }: DeliveryDescription) => {
  useEffect(() => {
    const orderMore = document.querySelector('.orderMore');
    const orderMoreHide = document.querySelector('.orderMoreHide');
    orderMore?.addEventListener('click', () => {
      orderMoreHide.classList.toggle('active');
    });
  }, []);
  return (
    <>
      <Htag tag={'h3'}>{name}</Htag>
      <WrapperDeliveryBlock>
        <div dangerouslySetInnerHTML={{ __html: description || '' }} />
      </WrapperDeliveryBlock>
    </>
  );
};
